module.exports = __webpack_public_path__ + "/img/Header-Male-Right-Angle-Labeled-NdTqjc.svg";